// extracted by mini-css-extract-plugin
export default {"button":"vnle6_wKIlVNg5qxcRu5"};